/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/21
 */

import React from "react";
import {Stack, Typography, TypographyProps} from "@mui/material";

export interface HeroMessageProps {
	title?: string
	titleTypographyProps?: TypographyProps
	message?: string | React.ReactElement
	messageTypographyProps?: TypographyProps
	p?: number
}

export default function HeroMessage(props: HeroMessageProps) {

	return (
		<Stack sx={{ p: (props.p ?? 20) }} alignItems={"center"} justifyContent={"center"} spacing={1}>
			{props.title && <Typography variant={"h4"} {...(props.titleTypographyProps||{}) }>{props.title}</Typography>}
			{props.message && <Typography color={"textSecondary"} {...(props.messageTypographyProps||{}) }>{props.message}</Typography>}
		</Stack>
	);

}